import {useEffect, useEffectEvent, useState} from 'react';
import {QueryStatus} from '@reduxjs/toolkit/query/react';
import type {HttpError} from 'api/http/types';
import type {DataLoadStatus} from 'api/types';
import {useLazyGetManifestationQuery} from '../manifestationApi';
import {useLazyGetWorkQuery} from '../workApi';
import type {WorkMetadata} from '../types';

export const useWorkForManifestation = (
  manifestationId: string | undefined,
): DataLoadStatus<WorkMetadata> => {
  const [result, setResult] = useState<DataLoadStatus<WorkMetadata>>({
    status: 'NotLoaded',
  });
  const [callerManifestation, {status}] = useLazyGetManifestationQuery();
  const [callerWork] = useLazyGetWorkQuery();

  const setResultEffect = useEffectEvent(setResult);

  useEffect(() => {
    if (manifestationId && status === QueryStatus.uninitialized) {
      setResultEffect(old => ({status: 'Loading', data: old.data}));
      callerManifestation(manifestationId)
        .unwrap()
        .then(manifestation => callerWork({id: manifestation.workId}).unwrap())
        .then(data => setResultEffect(() => ({status: 'Loaded', data})))
        .catch((error: HttpError) =>
          setResultEffect(() => ({status: 'Failed', error})),
        );
    }
    // Only trigger if manifestationId changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manifestationId]);

  return result;
};
